var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ShopView',[_c('h1',{staticClass:"mb-6 d-flex align-center"},[_vm._v(" "+_vm._s(_vm.$t('pageTitles.shop.brands'))+" ")]),_c('BrandShopList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }